<template>
    <div class="right_col" role="main">
        <div class="clearfix"></div>
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12 ">
                <div class="x_panel statistics-bg text-white">
                    <div class="x_title">
                        <h2>
                            <i class="fa fa-bar-chart" aria-hidden="true"></i> Total Sale
                        </h2>
                        <div class="clearfix"></div>
                    </div>
                    <div class="x_content">
                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                           <router-link class="text-white"
                                        :to="{path: 'pinsubscriptionreport'}">Agent {{pinWordReplacementWith}}</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{ts_rp}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                          <router-link class="text-white" :to="{path: 'pinsubscriptionreport'}">Self {{pinWordReplacementWith}}</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{ts_wp}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                           <router-link class="text-white" :to="{path: 'pinsubscriptionreport'}">Total</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{ts_sum}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 ">
                <div class="x_panel statistics-bg text-white">
                    <div class="x_title">
                        <h2>
                            <i class="fa fa-compress" aria-hidden="true"></i> Self {{pinWordReplacementWith}} Comparison
                        </h2>
                        <div class="clearfix"></div>
                    </div>
                    <div class="x_content">
                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                           <router-link class="text-white" :to="{path: 'pinsubscriptionreport'}">Today Now</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{opc_today}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                          <router-link class="text-white"
                                       :to="{path: 'pinsubscriptionreport'}">Yesterday was</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{opc_yes}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                           <router-link class="text-white"
                                        :to="{path: 'pinsubscriptionreport'}">Yes. day Total</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{yestotal}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 ">
                <div class="x_panel statistics-bg text-white">
                    <div class="x_title">
                        <h2>
                            <i class="fa fa-compress" aria-hidden="true"></i> Agent {{pinWordReplacementWith}}
                            Comparison
                        </h2>
                        <div class="clearfix"></div>
                    </div>
                    <div class="x_content">
                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                           <router-link class="text-white" :to="{path: 'pinsubscriptionreport'}">Today Now</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{rpc_today}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                          <router-link class="text-white"
                                       :to="{path: 'pinsubscriptionreport'}">Yesterday was</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{rpc_yes}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                           <router-link class="text-white"
                                        :to="{path: 'pinsubscriptionreport'}">Yes. day Total</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{rpc_sum}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 ">
                <div class="x_panel statistics-bg text-white">
                    <div class="x_title">
                        <h2>
                            <i class="fa fa-compress" aria-hidden="true"></i> Life Time Sales
                        </h2>
                        <div class="clearfix"></div>
                    </div>
                    <div class="x_content">
                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                           <router-link class="text-white"
                                        :to="{path: 'pinsubscriptionreport'}">Total {{pinWordReplacementWith}}</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{life_time_total_pins}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                        <div class="widget_summary">
                            <div class="w_left w_25">
                        <span>
                          <router-link class="text-white"
                                       :to="{path: 'pinsubscriptionreport'}">Total Price </router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                                <span>{{life_time_total_pins_price}}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="widget_summary mb-3">
                            <div class="w_left w_25">
                        <span>
                          <router-link class="text-white" :to="{path: 'pinsubscriptionreport'}">&nbsp;</router-link>
                        </span>
                            </div>
                            <div class="w_center w_55">
                            </div>
                            <div class="w_right w_20">
                                <span>&nbsp;</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="animated flipInY col-lg-3 col-md-6 col-sm-6 ">
                <div class="tile-stats">
                    <div class="icon"><i class="fa fa-heart-o" aria-hidden="true"></i></div>
                    <div class="count">
                        <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                        {{totSubscribedPin}}
                    </div>
                    <h3>Total Subscribed</h3>
                    <p>&nbsp;</p>
                </div>
            </div>
            <div class="animated flipInY col-lg-3 col-md-6 col-sm-6 ">
                <div class="tile-stats">
                    <div class="icon"><i class="fa fa-clock-o" aria-hidden="true"></i></div>
                    <div class="count">
                        <img v-if="loading_data" :src="loaderGif" alt="Loading"/>
                        {{todSubscribedPin}}
                    </div>
                    <h3>Today Subscribed</h3>
                    <p>&nbsp;</p>
                </div>
            </div>
            <div class="animated flipInY col-lg-3 col-md-6 col-sm-6 ">
                <div class="tile-stats">
                    <div class="icon"><i class="fa fa-sort-amount-desc"></i></div>
                    <div class="count">{{totRecharge}}</div>
                    <h3>Total Recharge</h3>
                    <p>&nbsp;</p>
                </div>
            </div>
            <div class="animated flipInY col-lg-3 col-md-6 col-sm-6 ">
                <div class="tile-stats">
                    <div class="icon"><i class="fa fa-money" aria-hidden="true"></i></div>
                    <div class="count">{{todRecharge}}</div>
                    <h3>Today Recharge</h3>
                    <p>&nbsp;</p>
                </div>
            </div>
        </div>

        <!--Subscription Graph Start-->
        <SubscribePinsGraph v-if="renderComponent"/>
        <!--Subscription Graph End-->

        <!--Hourly Pin subscription report for last 7 day-->
        <HourlyPinSection v-if="renderComponent"/>
        <!--End Hourly Pin subscription report for last 7 day-->

        <br>
        <!--Secton two start-->
        <div class="row">
            <!--Secton two start-->
            <div class="col-md-4">
                <div class="">
                    <div class="box-header">
                        <div class="box-tools pull-right">
                            <a class="fa fa-refresh" @click="loadTopResellerData"></a> |
                            <router-link :to="{path: 'individualsoldpinreport'}"> See More</router-link>
                        </div>
                        <h3 class="box-title dashboardLevel"> Today Top 5 VPN Agent</h3>
                    </div>
                    <div class="box-body">
                        <table class="table table-0024 table-fixed-height table-bordered table-striped">
                            <thead>
                            <tr>
                                <th class="tdCenter tdSN">SN</th>
                                <th class="tdCenter">Agent</th>
                                <th class="tdCenter">Sold {{pinWordReplacementWith}}s</th>
                            </tr>
                            </thead>
                            <tbody id="get_top_5_reseller_report_bodyid">
                            <tr v-for="(data,index) in topResellerArr" :key="data.id">
                                <td class="tdCenter tdSN">
                                    {{parseInt(++index)}}
                                </td>
                                <td class=" success">
                                    {{reseller_list[data.id_reseller+':'+data.level]}}
                                </td>
                                <td class="tdCenter">{{data.total_pins}}</td>
                            </tr>
                            <tr v-if="topResellerArr.length==0 && !tbl1_loading_data">
                                <td colspan="3" class="tdCenter" style="padding: 30px 0;"><b>No Records
                                    Found</b>
                                </td>
                            </tr>
                            <tr v-if="topResellerArr.length == 0 && tbl1_loading_data">
                                <img src="/assets/img/loading_h.gif" alt="Loading"/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="">
                    <div class="box-header">
                        <div class="box-tools pull-right">
                            <a class="fa fa-refresh" @click="loadRechargeData"></a> |
                            <router-link :to="{path: 'transactionreport'}">
                                See More
                            </router-link>
                        </div>
                        <h3 class="box-title dashboardLevel">Last 5 VPN Recharge</h3>
                    </div>
                    <div class="box-body">
                        <table class="table table-0024 table-fixed-height table-bordered table-striped">
                            <thead>
                            <tr>
                                <th class="tdCenter tdSN">SN</th>
                                <th class="tdCenter">Agent</th>
                                <th class="tdCenter">Date</th>
                                <th class="tdCenter">Amount</th>
                            </tr>
                            </thead>
                            <tbody id="get_last_5_recharge_report_bodyid">
                            <tr v-for="(data,index) in rechargeArr" :key="data.id">
                                <td class="tdCenter tdSN">
                                    {{parseInt(++index)}}
                                </td>
                                <td class=" success">{{data.login}}</td>
                                <td class="tdCenter">{{data.creationdate}}</td>
                                <td class="info tdCenter"> {{data.amount}}</td>
                            </tr>
                            <tr v-if="rechargeArr.length==0 && !loading_data">
                                <td colspan="4" class="tdCenter" style="padding: 30px 0;"><b>No Records
                                    Found</b>
                                </td>
                            </tr>
                            <tr v-else>
                                <img v-if="loading_data" src="/assets/img/loading_h.gif" alt="Loading"/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="">
                    <div class="box-header">
                        <div class="box-tools pull-right">
                            <a class="fa fa-refresh" @click="loadPaymentData"></a> |
                            <router-link :to="{path: 'paymentreport'}"> See More</router-link>
                        </div>
                        <h3 class="box-title dashboardLevel"> Last 5 VPN Payments</h3>
                    </div>
                    <div class="box-body">
                        <table class="table table-0024 table-fixed-height table-bordered table-striped">
                            <thead>
                            <tr>
                                <th class="tdCenter tdSN">SN</th>
                                <th class="tdCenter">Date</th>
                                <th class="tdCenter">Description</th>
                                <th class="tdCenter">Amount</th>
                            </tr>
                            </thead>
                            <tbody id="get_last_5_payments_report_bodyid">
                            <tr v-for="(data,index) in paymentArr" :key="data.id">
                                <td class="tdCenter tdSN">
                                    {{parseInt(++index)}}
                                </td>
                                <td class="tdCenter">{{data.creationdate}}</td>
                                <td class="tdCenter">{{data.description}}</td>
                                <td class="info tdCenter"> {{data.amount}}</td>
                            </tr>
                            <tr v-if="paymentArr.length==0 && !loading_data">
                                <td colspan="4" class="tdCenter" style="padding: 30px 0;"><b>No Records
                                    Found</b>
                                </td>
                            </tr>
                            <tr v-else>
                                <img v-if="loading_data" src="/assets/img/loading_h.gif" alt="Loading"/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!--Secton two end-->

    </div>
</template>
<script>
    import axios from 'axios'
    import HourlyPinSection from "@/components/dashboardComponents/HourlyPinSection.vue";
    import SubscribePinsGraph from "@/components/dashboardComponents/SubscribePinsGraph.vue";

    export default {
        name: "Dashboard",
        components: {
            HourlyPinSection,
            SubscribePinsGraph,
        },
        data() {
            return {
                pinWordReplacementWith: process.env.VUE_APP_PIN_WORD_REPLACEMENT_WITH,
                loaderGif: '/assets/img/loading_h.gif',
                statisticsDividedBy: 50,
                renderComponent: true,
                refresh_datetime: '',
                loading_data: true,
                ts_rp: '',
                ts_wp: '',
                ts_sum: '',
                opc_today: '',
                opc_yes: '',
                yestotal: '',
                rpc_today: '',
                rpc_yes: '',
                rpc_sum: '',
                life_time_total_pins: '',
                totSubscribedPin: '',
                todSubscribedPin: '',
                life_time_total_pins_price: '',
                totRecharge: '',
                todRecharge: '',

                totalOnlineSubscribedPin: '',
                todayOnlineSubscribedPin: '',
                showOnlinePinData: false,

                self_indicator: '',
                reseller_indicator: '',

                tbl1_loading_data: true,

                reseller_list: {},
                paymentArr: [],
                rechargeArr: [],
                topResellerArr: [],
            }
        },
        props: {
            msg: String,
        },
        created() {
            this.com_user_type_access([0, 1], true);
            this.loadDashboardData();
            this.loadPaymentData();
            this.loadRechargeData();
            this.loadTopResellerData();
            this.showOnlinePinData = this.com_onlineReportAccess();
        },
        methods: {
            loadDashboardData() {
                var rootObj = this;
                loader.show();
                this.refresh_datetime = this.com_currentDateTime('dmy');

                const form = new FormData()
                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                }
                axios.post('dashboard/load-dashboard-pin-count-data', form, config).then(function (response) {
                    var dashboardData = response.data.data;
                    //console.log(dashboardData);

                    rootObj.loading_data = false;
                    rootObj.ts_rp = parseInt(dashboardData.totalSubscribedPin) - parseInt(dashboardData.totalMySubscribedPin);
                    rootObj.ts_wp = parseInt(dashboardData.totalMySubscribedPin);
                    rootObj.ts_sum = parseInt(dashboardData.totalSubscribedPin);

                    if (parseInt(dashboardData.todayMySubscribedPin) > parseInt(dashboardData.yseterdayMySubscribedPin)) {
                        rootObj.opc_today = dashboardData.todayMySubscribedPin;
                    } else if (parseInt(dashboardData.todayMySubscribedPin) < parseInt(dashboardData.yseterdayMySubscribedPin)) {
                        rootObj.opc_today = dashboardData.todayMySubscribedPin;
                    } else {
                        rootObj.opc_today = dashboardData.todayMySubscribedPin;
                    }

                    if ((parseInt(dashboardData.todaySubscribedPin) - parseInt(dashboardData.todayMySubscribedPin)) > (parseInt(dashboardData.yseterdaySubscribedPin) - parseInt(dashboardData.yseterdayMySubscribedPin))) {
                        rootObj.rpc_today = dashboardData.todaySubscribedPin - dashboardData.todayMySubscribedPin;
                    } else if ((parseInt(dashboardData.todaySubscribedPin) - parseInt(dashboardData.todayMySubscribedPin)) < (parseInt(dashboardData.yseterdaySubscribedPin) - parseInt(dashboardData.yseterdayMySubscribedPin))) {
                        rootObj.rpc_today = dashboardData.todaySubscribedPin - dashboardData.todayMySubscribedPin;
                    } else {
                        rootObj.rpc_today = dashboardData.todaySubscribedPin - dashboardData.todayMySubscribedPin;
                    }

                    rootObj.opc_yes = dashboardData.yseterdayMySubscribedPin;
                    rootObj.yestotal = dashboardData.yseterdayMyTotalSubscribedPin;
                    rootObj.rpc_yes = dashboardData.yseterdaySubscribedPin - dashboardData.yseterdayMySubscribedPin;
                    rootObj.rpc_sum = dashboardData.yesterdayTotalSubscribedPin - dashboardData.yseterdayMyTotalSubscribedPin;
                    rootObj.life_time_total_pins = dashboardData.lifetimePinSubscription;
                    rootObj.life_time_total_pins_price = parseInt(dashboardData.lifetimePinSubscriptionSalesValue);
                    rootObj.totSubscribedPin = dashboardData.totalSubscribedPin;
                    rootObj.todSubscribedPin = dashboardData.todaySubscribedPin;
                    rootObj.totRecharge = parseInt(dashboardData.totalRecharge);
                    rootObj.todRecharge = parseInt(dashboardData.todayRecharge);
                    rootObj.totalOnlineSubscribedPin = parseInt(dashboardData.totalOnlineSubscribedPin);
                    rootObj.todayOnlineSubscribedPin = parseInt(dashboardData.todayOnlineSubscribedPin);
                    rootObj.self_indicator = 0;
                    if (rootObj.opc_today > rootObj.opc_yes) {
                        rootObj.self_indicator = 1;
                    }
                    if (rootObj.opc_today < rootObj.opc_yes) {
                        rootObj.self_indicator = 2;
                    }

                    rootObj.reseller_indicator = 0;
                    if (rootObj.rpc_today > rootObj.rpc_yes) {
                        rootObj.reseller_indicator = 1;
                    }
                    if (rootObj.rpc_today < rootObj.rpc_yes) {
                        rootObj.reseller_indicator = 2;
                    }

                })
                    .catch(function (error) {
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        console.log(alertmessage);
                        rootObj.loading_data = false;
                        loader.hide();
                        rootObj.com_errorHandel(error);
                    });

                setTimeout(function () {
                    loader.hide();
                }, 1000);
            },

            loadPaymentData() {
                var rootObject = this;
                const form = new FormData()
                form.append('noDateFilter', true)
                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                }
                axios.post('reports/payment-report', form, config).then(function (response) {
                    rootObject.populatePaymentArrData(response);
                })
                    .catch(function (error) {
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        console.log(alertmessage);
                        loader.hide();
                        rootObject.com_errorHandel(error);
                    });
            },

            populatePaymentArrData(response) {
                this.paymentArr = [];
                for (var prop in response.data.data) {
                    response.data.data[prop]['amount'] = parseFloat(response.data.data[prop]['amount']).toFixed(2);
                    var creationdate = this.com_displayDateFormat(response.data.data[prop]['creationdate']);
                    response.data.data[prop]['creationdate'] = creationdate.date;
                    response.data.data[prop]['description'] = (response.data.data[prop]['description']).substr(0, 10);
                    this.paymentArr.push(response.data.data[prop]);

                }
            },

            loadRechargeData() {
                var rootObject = this;
                const form = new FormData()
                form.append('noDateFilter', true)
                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                }
                axios.post('reports/transaction-report', form, config).then(function (response) {
                    rootObject.populateRechargeArrData(response);
                })
                    .catch(function (error) {
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        console.log(alertmessage);
                        loader.hide();
                        rootObject.com_errorHandel(error);
                    });
            },

            populateRechargeArrData(response) {
                //console.log(response);
                this.rechargeArr = [];
                for (var prop in response.data.data) {
                    response.data.data[prop]['amount'] = parseFloat(response.data.data[prop]['amount']).toFixed(2);
                    var creationdate = this.com_displayDateFormat(response.data.data[prop]['creationdate']);
                    response.data.data[prop]['creationdate'] = creationdate.date;
                    this.rechargeArr.push(response.data.data[prop]);
                }
            },

            loadTopResellerData() {
                var rootObject = this;
                this.tbl1_loading_data = true;
                axios.get('get-reseller-dropdown-data').then(function (response) {
                    rootObject.reseller_list = response.data.data;
                    rootObject.tbl1_loading_data = false;
                })
                    .catch(function (error) {
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        console.log(alertmessage);
                        rootObject.tbl1_loading_data = false;
                        rootObject.com_errorHandel(error);
                    });

                var today = this.com_currentDateTime('', 'no');
                const form = new FormData()
                form.append('report_type', 3)
                form.append('fromDate', today)
                form.append('toDate', today)
                form.append('take_rows', 5)
                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                }
                axios.post('reports/pin-subscription', form, config).then(function (response) {
                    rootObject.populateTopResellerArrData(response);
                })
                    .catch(function (error) {
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        console.log(alertmessage);
                        rootObject.com_errorHandel(error);
                    });
            },

            populateTopResellerArrData(response) {
                //console.log(response);
                this.topResellerArr = response.data.data;
            },

            refreshDashboard() {
                this.loadDashboardData();
                this.forceRerender();
                this.loadTopResellerData();
                this.loadRechargeData();
                this.loadPaymentData();
            },

            forceRerender() {
                // Remove my-component from the DOM
                this.renderComponent = false;
                this.$nextTick(() => {
                    // Add the component back in
                    this.renderComponent = true;
                });
            }
        },
        mounted: function () {

        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .w_25 {
        width: 80% !important;
    }
</style>